<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboard' }">Dashboard</router-link>
              </li>
              <li class="breadcrumb-item active">Open New Ticket</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-8">
            <div class="card">
              <div class="card-header">
                <div class="card-tools">
                  <h3 class="card-title">Write Your Message</h3>
                </div>
              </div>

              <form @submit.prevent="OpenTicket" method="POST" novalidate>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group required">
                        <label for="fullName">Full Name</label>
                        <input type="text" class="form-control" id="fullName" name="fullName" v-model="ticket.fullName"
                          v-validate="'required'" placeholder="Full Name" />
                        <div class="help text-danger" v-show="errors.has('fullName')">
                          {{ String(errors.first("fullName")).replace('fullName', 'Full Name') }}
                        </div>
                      </div>
                      <div class="form-group required">
                        <label for="customer_email">Email address</label>
                        <input type="text" class="form-control" id="customer_email" name="customer_email"
                          v-model="ticket.customer_email" v-validate="'required|email'" placeholder="Email address" />
                        <div class="help text-danger" v-show="errors.has('customer_email')">
                          {{ String(errors.first("customer_email")).replace('customer_email', 'Email address') }}
                        </div>
                      </div>
                      <div class="form-group required">
                        <label for="phone">Phone number</label>
                        <input type="text" class="form-control" id="phone" name="phone" v-model="ticket.phone"
                          placeholder="Phone number" v-validate="'required'" />
                        <div class="help text-danger" v-show="errors.has('phone')">
                          {{ String(errors.first("phone")).replace('phone', 'Phone number') }}
                        </div>
                      </div>

                      <div class="form-group required">
                        <label for="complain_type_id">Query Type</label>
                        <multiselect v-model="ticket.complain_type_id" :options="pre.complain_types.map((o) => o.id)"
                          placeholder="Select" :searchable="true" :multiple="false" :class="{
                            'has-error': errors.has('complain_type_id'),
                          }" :custom-label="(opt) => {
                            let z = pre.complain_types.find(
                              (x) => x.id == opt
                            );
                            return z ? z.complain_type : '';
                          }
                            " id="complain_type_id" name="complain_type_id" v-validate="'required'">
                        </multiselect>

                        <div class="help text-danger" v-show="errors.has('complain_type_id')">
                          {{ String(errors.first("complain_type_id")).replace('complain_type_id', 'Query Type') }}
                        </div>

                      </div>

                      <div class="form-group required">
                        <label for="title">Subject</label>
                        <input type="text" class="form-control" id="title" name="title" v-model="ticket.title"
                          v-validate="{ required: true, max: 255, regex: /^[\;\:\?\(\)-,<>\'\.\w\s]+$/ }"
                          placeholder="Subject" />
                        <div class="help text-danger" v-show="errors.has('title')">
                          {{ String(errors.first("title")).replace('title', 'Subject') }}
                        </div>
                      </div>

                      <div class="form-group required">
                        <label for="body">Write your message</label>
                        <textarea class="form-control" id="body" name="body" rows="8" cols="10" v-model="ticket.body"
                          v-on:keyup="checkMaxSize" placeholder="Write your message"
                          :class="{ 'has-error': errors.has('body') }" v-validate="'required|max:1000'">
                        </textarea>
                        <div class="help text-danger" v-show="errors.has('body')">
                          {{ String(errors.first("body")).replace('body', 'Message') }}
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="attachment">Attachments</label>
                        <table class="table table-bordered">
                          <thead>
                            <tr>
                              <th class="text-center" scope="col">SL.</th>
                              <th class="text-center" scope="col">File Name</th>
                              <th class="text-center" scope="col">Action</th>
                            </tr>
                          </thead>
                          <tbody class="t-body">
                            <tr class="text-center" v-for="(item, index) in ticket.attachments">
                              <td class="text-center">{{ index + 1 }}</td>
                              <td class="text-center">{{ item.name }}</td>
                              <td class="text-center">
                                <button type="button" class="btn btn-primary" @click.prevent="removeFileItem(item.id)">
                                  <i class="fa fa-trash" aria-hidden="true"></i>
                                </button>
                              </td>
                            </tr>
                            <tr v-if="ticket.attachments.length == 0">
                              <td class="text-center" colspan="100%"> No attachment found yet.</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="form-group">


                        <div class="input-group">
                          <div class="custom-file">
                            <input accept=".png, .jpg, .jpeg" type="file" name="attachment" class="custom-file-input"
                              id="attachment" @change="selectFile" />
                            <label class="custom-file-label" for="attachment">Choose file </label>
                          </div>
                        </div>

                      </div>



                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-3">
                      <button type="submit" class="btn btn-dark-blue">
                        <!-- <i class="fas fa-search"></i>  -->
                        Send Now
                      </button>
                      <!-- <button type="reset" class="btn btn-warning" @click="resetFilter()"><i class="fas fa-undo"></i> Reset</button> -->
                    </div>
                  </div>
                </div>
              </form>
              <div class="overlay" v-if="is_loading">
                <i class="fas fa-2x fa-sync-alt fa-spin"></i>
              </div>

              <div class="card-footer">
                <vue-pagination :pagination="list" v-if="list.total > list.per_page" @paginate="getUsageData()" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<style scoped>
div.card-body label {
  font-weight: 12;
  display: inline-flex;
}

button.btn-common {
  width: 100%;
  display: inline-flex;
  justify-content: center;
  background-color: #3c206b !important;
}

/* .required label:after {
    color: #e32;
    content: ' *';
    display:inline;
} */

.form-group.required label:after {
  content: " *";
  color: red;
  padding-left: 0.25em;
}
</style>
<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { CommonAPI } from "@/services/api";
const fileDownload = require("js-file-download");
import { Notification } from "element-ui";
import { includes } from "lodash";

export default {
  name: "OpenTicket",
  metaInfo: {
    title: "Create Ticket",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
  },

  data: () => ({
    ticket: {
      fullName: "",
      customer_email: "",
      phone: "",
      complain_type: 0,
      title: "",
      body: "",
      cuid: "",
      attachments: []
    },

    list: {
      total: 0,
      per_page: 3,
      from: 1,
      to: 0,
    },
    order_by: "asc",
    api_url: "",
    showFilter: false,
    filter: {},
    dateRange: "",
    pre: {
      complain_types: [],
    },
    is_loading: false,
    has_permission: true,
    max_file_size: 5 * 1024 * 1024, // max allowed file size in byte, 5MB
    companyName: process.env.VUE_APP_COMPANY_NAME || '',
  }),
  // method is called after page load
  mounted: function () {
    // if (this.isMobile()) {
    //   window.$(document).find('.push-menu-class').trigger('click');
    // }

    //console.log("Open ticekt");
    this.companyName = process.env.VUE_APP_COMPANY_NAME || '';
    this.getAccountDetail();
    this.loadOptions();
    // this.api_url = '/admin_users';
    // this.getUsageData();
    // // this.getOrganization();
    // this.$root.$on('sort-data', () => {
    //   this.$root.$emit('show-icon');
    //   this.getUsageData();
    // });
  },

  metaInfo() {
    return {
      title: this.companyName
        ? `Create Ticket | ${this.companyName}`
        : "Create Ticket",
    };
  },

  methods: {

    checkMaxSize: function ($event) {
      if (this.ticket.body.length > 1000) {
        this.$toaster.error("Sorry!, your input limit exceeded.");
        this.ticket.body = this.ticket.body.slice(0, 1000);
      }
    },

    removeFileItem: function (id) {
      //this.ticket.files
      console.log("Id::", id);
      console.log("Current List:::", this.ticket.attachments);
      this.ticket.attachments = this.ticket.attachments.filter(x => x.id !== id);
    },
    selectFile: function (event) {
      // `files` is always an array because the file input may be in multiple mode
      const file = event.target.files[0];
      console.log("File object::", file);
      const uploadFileSize = file.size // file size in byte
      // accept only .png, .jpg, .jpeg
      console.log(file.type);
      const allowedExtensionRegex = (/(jpg|jpeg|png)$/i);

      if (!allowedExtensionRegex.test(file.type)
      ) {
        this.$toaster.error("Please Select an image file with extension [ png, jpg, jpeg ]");
        return false;
      }
      if (uploadFileSize > this.max_file_size) {
        this.$toaster.error("Please Select a file smaller than 5MB");
        return false;
      }

      if (this.ticket.attachments.length >= 5) {
        this.$toaster.error("Sorry!, number of attachment exceeded.");
        return false;
      }

      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // this.value.avatar = reader.result;
        // this.temp_avatar = reader.result;
        console.log("Reader Result::", reader.result);
        const uniqueId = new Date().getTime(); // miliseconds since 1st Jan 1970
        this.ticket.attachments.push({ id: uniqueId, name: file.name, size: file.size, data: reader.result });
      };
    },

    loadOptions: function () {
      let _this = this;
      axios.get("get_query_types").then((response) => {
        //console.log('response.data::', response.data);
        _this.pre.complain_types = response.data;
      });
    },

    getAccountDetail: function () {
      let api_url = "/get-account-info";
      let _this = this;
      _this.is_loading = true;
      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      if (subscriber) {
        axios
          .get(api_url, { params: { cuid: subscriber.username } })
          .then((response) => {
            //console.log('response.data::', response.data);
            _this.ticket.fullName =
              response.data.firstName + " " + response.data.lastName;
            _this.ticket.customer_email = response.data.email;
            _this.ticket.phone = response.data.phone;
            _this.ticket.cuid = response.data.cuid;
            _this.is_loading = false;
          })
          .catch((error) => {
            console.log("error " + error);
            _this.is_loading = false;
          });
      }
    },

    OpenTicket() {
      let _this = this;
      _this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/create-ticket";
          let method = "POST";
          //return;
          // console.log(this.ticket);
          axios({
            method: method,
            url: api_url,
            data: _this.ticket,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.is_loading = false;
              _this.$toaster.success(response.data.message);

              // clear object property values
              Object.keys(_this.ticket).forEach((key) => {
                _this.ticket[key] = null;
              });

              _this.$router.push({ name: "support-ticket" });
            })
            .catch((errors) => {
              //alert("Error happend!");
              // console.log("Errors:::", errors);
              //console.log("Errors:::", response);
              console.log(errors.response.data);
              _this.$setErrorsFromResponse(errors.response.data);
              //   _this.$setErrorsFromResponse(errors.response.data.errors);
            })
            .finally(() => {
              _this.is_loading = false;
            });
        } else {
          console.log("Validation failed");
          console.log("Validation Error:::", this.errors.all());
        }
      });
    },

    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD hh:mm:ss");
    },

    getUsageData() { },

    getUsers() { },

    apiUsage(query = null) {
      return new Promise((resolve, reject) => {
        axios
          .get(this.api_url, {
            params: query,
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            if (error.response.status === 403) {
              this.has_permission = false;
            }
            reject(error);
          });
      });
    },
  },
};
</script>
